export default __webpack_public_path__ + "static/media/dollar-icon.3f9d6a3a.svg";